import InfoLinkBlock from './InfoLinkBlock';

export default InfoLinkBlock;
